import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box,
    Stack,
    Tooltip
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
const PreviewModal = ({ open, onClose, fileSrc, fileType }) => {
    const isPDF = fileType?.toLowerCase()?.includes('pdf');
    const [zoom, setZoom] = useState(1);
    const [rotation, setRotation] = useState(0);
    const fileUrl = isPDF ? `data:application/pdf;base64,${fileSrc}` : `data:image/png;base64,${fileSrc}`;
    const handleZoomIn = () => setZoom((prev) => Math.min(prev + 0.2, 3));
    const handleZoomOut = () => setZoom((prev) => Math.max(prev - 0.2, 0.2));
    const handleRotateLeft = () => setRotation((prev) => prev - 90);
    const handleRotateRight = () => setRotation((prev) => prev + 90);
    const resetControls = () => {
        setZoom(1);
        setRotation(0);
    };
    return (
        <Dialog open={open} onClose={() => { onClose(); resetControls(); }} maxWidth="md" fullWidth>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                {<span></span>}
                <IconButton onClick={() => { onClose(); resetControls(); }} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ height: '80vh', position: 'relative' }}>
                {!isPDF && (
                    <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                        <Tooltip title="Zoom In">
                            <IconButton onClick={handleZoomIn}><ZoomInIcon /></IconButton>
                        </Tooltip>
                        <Tooltip title="Zoom Out">
                            <IconButton onClick={handleZoomOut}><ZoomOutIcon /></IconButton>
                        </Tooltip>
                        <Tooltip title="Rotate Left">
                            <IconButton onClick={handleRotateLeft}><RotateLeftIcon /></IconButton>
                        </Tooltip>
                        <Tooltip title="Rotate Right">
                            <IconButton onClick={handleRotateRight}><RotateRightIcon /></IconButton>
                        </Tooltip>
                    </Stack>
                )}
                {isPDF ? (
                    <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                        <Viewer fileUrl={fileUrl} />
                    </Worker>
                ) : (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            overflow: 'auto',
                            height: '100%',
                        }}
                    >
                        <img
                            src={fileUrl}
                            alt="Preview"
                            style={{
                                transform: `scale(${zoom}) rotate(${rotation}deg)`,
                                transition: 'transform 0.3s ease',
                                maxWidth: '100%',
                                maxHeight: '100%',
                            }}
                        />
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
};
export default PreviewModal;